import React from "react";

export interface FormSkeletonProps {
 fields?: number;
 showRichEditor?: boolean;
 className?: string;
}

export const FormSkeleton: React.FC<FormSkeletonProps> = ({
 fields = 5,
 showRichEditor = false,
 className = "",
}) => {
 return (
  <div className={`space-y-6 ${className}`}>
   {Array.from({ length: fields }).map((_, index) => (
    <div key={index} className="space-y-2">
     <div className="h-4 bg-gray-200 rounded w-24 animate-pulse" />
     <div className="h-10 bg-gray-200 rounded animate-pulse" />
    </div>
   ))}
   {showRichEditor && (
    <div className="space-y-2">
     <div className="h-4 bg-gray-200 rounded w-24 animate-pulse" />
     <div className="border border-gray-300 overflow-hidden">
      <div className="h-12 bg-gray-100 animate-pulse" />
      <div className="h-64 bg-gray-50 animate-pulse" />
     </div>
    </div>
   )}
  </div>
 );
};

export default FormSkeleton;

